import { getPostHogAnalyticsConfig } from "./config";
import type { AnalyticsEventName, AnalyticsEventProperties } from "./events";
import { getPostHogClient, isPostHogAnalyticsEnabled } from "./posthog-client";
import { sanitizeAnalyticsProperties } from "./sanitize";

export function captureAnalyticsEvent<TName extends AnalyticsEventName>(
  eventName: TName,
  properties: AnalyticsEventProperties<TName>
): void {
  if (!isPostHogAnalyticsEnabled()) return;
  getPostHogClient().capture(
    eventName,
    sanitizeAnalyticsProperties(properties as Record<string, unknown>)
  );
}

export function identifyAnalyticsUser(args: {
  userId: string | undefined;
  orgId?: string | undefined;
}): void {
  if (!isPostHogAnalyticsEnabled()) return;
  if (!args.userId) {
    getPostHogClient().reset();
    return;
  }

  getPostHogClient().identify(args.userId, sanitizeAnalyticsProperties({ org_id: args.orgId }));
}

export function resetAnalytics(): void {
  if (!isPostHogAnalyticsEnabled()) return;
  getPostHogClient().reset();
}

export function registerAnalyticsProperties(properties: object): void {
  if (!isPostHogAnalyticsEnabled()) return;
  getPostHogClient().register(sanitizeAnalyticsProperties(properties as Record<string, unknown>));
}

export function setAnalyticsGroup(
  groupType: "organization" | "project",
  groupKey: string | undefined
): void {
  if (!isPostHogAnalyticsEnabled() || !groupKey) return;
  getPostHogClient().group(
    groupType,
    groupKey,
    sanitizeAnalyticsProperties({ group_type: groupType })
  );
}

export function useAnalytics() {
  return {
    enabled: getPostHogAnalyticsConfig().enabled,
    capture: captureAnalyticsEvent,
  };
}
